import styled from "styled-components";
import { theme } from '../../../theme'
import {
    MdAssessment
} from "react-icons/md";
import { Button } from '../../../components/button'
import { Link } from "react-router-dom";


const Item = styled.div`
    display: flex;
    justify-content: space-around;
    align-items: center;
    padding: 1rem 0;
    border: 1px solid #DFE2E6;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.05);
    border-radius: 6px;
    background-color: ${theme.colors.mainWhite};
    margin-bottom: 1rem;
    position: relative;
`

const ImageContainer = styled.div`
    width: 3.5rem;
    height: 3.5rem;
    color: ${theme.colors.mainBlue};
    background: rgba(33, 150, 243, 0.44);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    // margin-right: 1.3rem;
    svg {
        height: 2.4rem;
        width: 2.4rem;
    }

    @media only screen and (max-width: 334px) {
        display: none;
    }
`

const TextContainer = styled.div`
// margin-right: auto;
    .main-header {
        font-weight: 600;
        font-size: 1.4rem;
        color: #3B3B42;
    }
    .sub-header {
        font-size: 1.2rem;
        color: #979797;
    }
`


const ExamListItem = () => {
    return (
        <Item>
            <ImageContainer>
                <MdAssessment />
            </ImageContainer>
            <TextContainer>
                <p className="main-header">Mathematics (MATJSS1)</p>
                <p className="sub-header">First Term Exam | 90 Mins</p>
            </TextContainer>
            <Link to="/student/examination/instructions">
                <Button style={{ width: '10rem', height: '2.5rem', fontSize: '1rem' }} variant="secondary">TAKE TEST/EXAM</Button>
            </Link>
        </Item>
    )
}

export default ExamListItem
